<template>
    <div id="app">
        <!--<transition name="slide-fade">-->
            <router-view></router-view>
        <!--</transition>-->
        <scroll-to-top></scroll-to-top>
    </div>
</template>
<script>
    // import  Vue from 'vue'
    var store;
    import  util from './utils/util'
    import scrollToTop from './components/scrollToTop'
    export default {
        components: {
            scrollToTop
        },
        mounted(){
        },
        created(){
            let self =  this;
            store = this.$store
            self.autoLogin()
        },
        methods: {
            autoLogin() {
                let checkToken = util.checkToken(store)
                console.log("是否登录:",checkToken);
                if (!checkToken) {
                    console.log("未登录");
                } else {
                    util.setUser(store)
                }
            }
        },
    }
</script>
<style lang="scss">
    @import './reset.css';
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        .slide-fade{
            /*position: absolute;left:0;right: 0;*/
        }
        .slide-fade-enter-active,.slide-fade-leave-active {
            /*transition: all 0.8s cubic-bezier(2.0, 0.5, 0.8, 1.0);*/
            transition: all 0.3s ease;
        }
        .slide-fade-enter, .slide-fade-leave-to
        {
            /*left:0;right: 0;*/
            /*transform: translateX(-100%);*/
            opacity: 0.5;
        }
    }
</style>
